import { z } from "zod";

export const ANNOTATION_BUG_ERROR_TYPE_VALUES = ["3d-error", "anatomical-error"] as const;

export const submitAnnotationBugReportSchema = z.object({
  modelSlug: z.string().min(1, "Model slug is required"),
  modelVersion: z.string().optional(),
  structureName: z.string().min(1, "Structure name is required"),
  structureId: z.string().optional(),
  structureCollection: z.string().optional(),
  latinName: z.string().optional(),
  errorType: z.enum(ANNOTATION_BUG_ERROR_TYPE_VALUES),
  description: z.string().min(1, "Description is required"),
  reportedAt: z.number().int().positive("Reported at must be a valid timestamp"),
});

export type AnnotationBugErrorType = (typeof ANNOTATION_BUG_ERROR_TYPE_VALUES)[number];
export type SubmitAnnotationBugReportRequest = z.infer<typeof submitAnnotationBugReportSchema>;
